import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type UiSettingsService from '@/services/domain/uiSettingsService'
import type { MonitoringServiceInterface } from '@/services/monitoring/types'

@injectable()
export default class UiSettingsResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.UiSettingsService)
    protected readonly uiSettingsService: UiSettingsService,
    @inject(SERVICE_TYPES.MonitoringService)
    protected readonly monitoringService: MonitoringServiceInterface,
  ) {}

  public async resolve() {
    try {
      await this.uiSettingsService.fetchSettings()
    } catch (e) {
      this.monitoringService.logError(e as Error)
      // Prevent crashing app on starting it
      await this.uiSettingsService.insertFallbackSettings()
    }
  }

  public async unresolve() {}

  public isFailed() {
    return false
  }
}
